import NoContentImg from "../assets/images/illustrations/search_no_results.svg";
import i18n from "../config/i18n";
import { useTranslation } from "react-i18next";

interface NoContentProps {
  specialty?: string;
}

function NoContent(props: NoContentProps) {
  const { t } = useTranslation();
  return (
    <div className="p-[22px]">
      <img src={NoContentImg} alt="" className="block mx-auto" />
      <div>
        <p className="font-dm-sans font-normal text-base leading-[120%] text-center tracking-[0.02em] text-primary-black">
          {t("Sorry! We haven't found any medical content related to")}{" "}
          {props.specialty}
        </p>
        <p className="font-dm-sans font-normal text-base leading-[120%] text-center tracking-[0.02em] text-primary-black">
          {t(
            "You can also scan and summarize automatically your publications by using the Blend feature."
          )}
        </p>
        <a
          className="font-dm-sans font-bold text-base leading-[120%] text-center tracking-[0.02em] text-primary-black mx-auto block underline"
          target="_blank"
          href={
            i18n.resolvedLanguage === "fr"
              ? "https://www.juisci.com/fr/mixez"
              : "https://www.juisci.com/blend"
          }
          rel="noreferrer"
        >
          {t("Discover more here.")}
        </a>
      </div>
    </div>
  );
}

export default NoContent;
